import { render, staticRenderFns } from "./addAkcc.vue?vue&type=template&id=18c951f3"
import script from "./addAkcc.vue?vue&type=script&lang=js"
export * from "./addAkcc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports